import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import gaTracker from './ga-tracker';

class SearchField extends Component {
	
	constructor(props) {
		super(props);
		this.preventDefault = this.preventDefault.bind(this);
		this.buttonMarkup = this.buttonMarkup.bind(this);
	}
	
	preventDefault(event) {
		event.preventDefault();
	}
	
	buttonMarkup() {
		return { __html: '<svg><use xlink:href="#icon-search"></use></svg>' }
	}
	
	render() {
		return (
			<form className="CountrySearch-form" onSubmit={ this.preventDefault }>
				<input
					type="text"
					className="CountrySearch-input"
					placeholder="Enter Country"
					onChange={ this.props.initSearch }
					value={ this.props.inputValue }
				/>
				<button
					type="button"
					className="CountrySearch-submit btn btn-primary"
					onClick={ this.props.initSearch }
					dangerouslySetInnerHTML={ this.buttonMarkup() }
				></button>
			</form>
		);
	}
}

export default class CountrySearch extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			userQuery: '',
			countries: this.props.data,
			showCountries: false
		};
		this.filterData = this.filterData.bind(this);
		this.handleUserInput = this.handleUserInput.bind(this);
	}
	
	handleUserInput(event) {
		
		this.setState({
			userQuery: event.target.value
		});
		
		// If the user hasn't entered anything then dont show anything.
		if (this.state.userQuery !== '') {
			this.filterData(event, event.target.value);
		}
		
		if (this.state.userQuery.length >= 2) {
			gaTracker.track('Country Search|value|' + this.state.userQuery);
		}
		
	}
	
	filterData(event, enteredValue) {
		
		event.preventDefault();
		
		let costs = []

		let filtered = [],
			userInput = enteredValue.toLowerCase();
			
		this.props.data.map((country) => {
			
			// If nothing matches then don't show anything.
			if (country.name.toLowerCase().indexOf(userInput) !== -1) {
				filtered.push(country);
			}
		});
		
		if(enteredValue === '') {
			this.setState({
				countries: filtered,
				showCountries: false
			});
		} else {
			this.setState({
				countries: filtered,
				showCountries: true
			});
		}


	}
		
	render() {
		
		let countryList = this.state.countries.map((country, index) => {
			return (
				<React.Fragment>
					<li key={ country.name }>{ country.name }</li>
					<li key={ `${country.name}-voice` }>{ country.voice }</li>
					<li key={ `${country.name}-sms` }>{ country.sms }</li>
					<li key={ `${country.name}-data` }>{ country.data }</li>
				</React.Fragment>
			);
		});
		
		let finePrint = this.state.countries.map((country) => {
			
			if (country.name.indexOf('*') !== -1) {
				return (<p className="Features-asterisk"><em>*Only Talk and Text are supported in this destination</em></p>);
			}
			
			return '';
		});
		
		return (
			<div className="CountrySearch" id="js-country-search">
				<h2>Search Rates by Country</h2>
				<SearchField
					inputValue={ this.state.userQuery }
					initSearch={ this.handleUserInput }
				/>

				{this.state.showCountries && 
				<React.Fragment>
					<ul className="CountrySearch-list ul-four-columns">
						<li class="heading">Country</li>
						<li class="heading">Voice Rate<br /><span>(per Min)</span></li>
						<li class="heading">SMS Rate<br /><span>(per SMS)</span></li>
						<li class="heading">Data Rate<br /><span>(per MB)</span></li>
						{ countryList }
					</ul>
					{ finePrint }
				</React.Fragment>
				}
			</div>
		);
	}
}

// Render the country search form field if the element is found on the appropriate "features" page.
if (document.getElementById('js-country-search')) {

	$.ajax({
		// not sure why this was being used but have commented it -- figured out why disabling it temporarily
		// url: (data_source.length > 0) ? data_source : window.location.origin + '/api/country-rates.json',
		
		url: window.location.origin + '/api/country-rates.json',
		success: function (response) {
			ReactDOM.render(
				<CountrySearch data={ response.countries } />,
				document.getElementById('js-country-search')
			);
		}
	});
}